import React from "react";
import "./Page3.css";

const Page3 = () => {
  return (
    <section className="page3-section">
      <div className="page3-container">
        <b className="page3-title"> What is Spatial Computing?</b>
        <p className="page3-description">
          Spatial computing extends desktop and mobile computing into 3D space,
          enabling digital systems to sense, map, and interact with the physical
          world in real time — boosting efficiency, training, and collaboration.
        </p>
                  <div className="page3-programs no-gap">
            <div className="page3-row">
              <div className="page3-image-box">
                <img src="/images/page2image1.webp" alt="Desktop Computing" />
              </div>
              <div className="page3-image-box">
                <img src="/images/page2image2.webp" alt="Mobile Computing" />
              </div>
              <div className="page3-image-box">
                <img src="/images/page2image3.webp" alt="Spatial Computing" />
              </div>
            </div>
          </div>

      </div>
    </section>
  );
};

export default Page3;
